import { type SugarProgramYear } from '@app/types'
import { find } from 'lodash'
import { useMemo } from 'react'

// MIQ-2640 rejects roster funding writes one item at a time for any enrollment
// whose program year starts before the 2026/27 Birth & Beyond year, and MIQ-2641
// applies the same cutoff to the attendance funding fields. The year pickers
// filter on `roster` / `attendance` flags with no B&B awareness, so without this
// a provider can fill in a whole sheet and have every row rejected.
// Mirrors the backend's fail-closed posture: a start date that cannot be parsed
// gates rather than permits.
const BANDB_START = Date.parse('2026-07-01')

// Parameterised rather than context-reading: the roster and the attendance sheet
// hold separate program-year selections in SugarContext, and both need this
// predicate against their own.
export const useFundingYearGate = (
  programYearId: string | null | undefined,
  programYears: SugarProgramYear[] | undefined
): boolean =>
  useMemo(() => {
    // Nothing selected yet is a loading state, not a gated one. Gating here
    // would flash the banner on every cold load, before `me` resolves.
    if (!programYearId) return false

    const start = Date.parse(find(programYears, ['id', programYearId])?.startDate ?? '')

    return Number.isNaN(start) || start < BANDB_START
  }, [programYearId, programYears])
